import React from 'react';
import { NavBarHeight } from '../constants';
import { FlyoutMenuContainer } from './Container/FlyoutMenuContainer';
import { FlyoutMenuBackdrop } from './Backdrop/FlyoutMenuBackdrop';
import { AnimatePresence, motion } from 'framer-motion';
import { flyoutTransition } from './config';
export const FlyoutMenu = ({ children, opened = false, onClose, contentKey, onMouseEnter, }) => {
    return (React.createElement("div", { role: "presentation", tabIndex: -1, onKeyDown: e => {
            if (e.key === 'Escape' && onClose) {
                e.stopPropagation();
                e.preventDefault();
                onClose();
            }
        } },
        React.createElement(AnimatePresence, { mode: "popLayout" }, opened && (React.createElement(FlyoutMenuBackdrop, null,
            React.createElement(motion.div, { key: "content", initial: { y: '-100%' }, animate: { y: '0%' }, exit: { y: '-100%' }, transition: flyoutTransition },
                React.createElement(FlyoutMenuContainer, { contentKey: contentKey, onClose: onClose },
                    React.createElement("div", { tabIndex: -1, onMouseEnter: onMouseEnter, style: { paddingTop: `calc(32px + ${NavBarHeight}px)` } }, children))))))));
};
//# sourceMappingURL=index.js.map